import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Table, Form, Select, Modal, message, InputNumber, Divider, Icon, Input, Radio, Row, Col, Switch, Badge, Alert } from 'antd';
import moment from 'moment';
import {
  constructColumnFilterCheckbox,
  constructColumnFilterRadio,
  constructColumnFilterSearch,
  constructColumn,
  handleOnAggregationTableChange
} from 'utils/table/table';
import { reservationCreateEinvoice, getLinkProfileList, createCustomerSelfServiceForm } from 'utils/apis/eInvoice';
import { REACT_APP_E_INVOICE_URL } from 'config/env';
import { withAppContext } from 'context/AppContext';
import { CSVLink } from 'react-csv';
import { guard } from 'utils/general';

const FormItem = Form.Item;
const { Option, OptGroup } = Select;
const planToEnableGuestSelfService = ['Pro', 'Pro (Promo)'];

const CreateEinvoiceModal = props => {
  const { getFieldDecorator, getFieldValue } = props.form;
  const { transactions } = props;

  const [loading, setLoading] = useState(false);
  const [formMode, setFormMode] = useState('customerService');
  const [isGuestSelfServiceEnabled, setIsGuestSelfServiceEnabled] = useState(false);
  const [countryList, setCountryList] = useState([
    {
      code: 'ABW',
      label: 'ARUBA'
    },
    {
      code: 'AFG',
      label: 'AFGHANISTAN'
    },
    {
      code: 'AGO',
      label: 'ANGOLA'
    },
    {
      code: 'AIA',
      label: 'ANGUILLA'
    },
    {
      code: 'ALA',
      label: 'ALAND ISLANDS'
    },
    {
      code: 'ALB',
      label: 'ALBANIA'
    },
    {
      code: 'AND',
      label: 'ANDORA'
    },
    {
      code: 'ARE',
      label: 'UNITED ARAB EMIRATES'
    },
    {
      code: 'ARG',
      label: 'ARGENTINA'
    },
    {
      code: 'ARM',
      label: 'ARMENIA'
    },
    {
      code: 'ASM',
      label: 'AMERICAN SAMOA'
    },
    {
      code: 'ATA',
      label: 'ANTARCTICA'
    },
    {
      code: 'ATF',
      label: 'FRENCH SOUTHERN TERRITORIES'
    },
    {
      code: 'ATG',
      label: 'ANTIGUA AND BARBUDA'
    },
    {
      code: 'AUS',
      label: 'AUSTRALIA'
    },
    {
      code: 'AUT',
      label: 'AUSTRIA'
    },
    {
      code: 'AZE',
      label: 'AZERBAIDJAN'
    },
    {
      code: 'BDI',
      label: 'BURUNDI'
    },
    {
      code: 'BEL',
      label: 'BELGIUM'
    },
    {
      code: 'BEN',
      label: 'BENIN'
    },
    {
      code: 'BES',
      label: 'BONAIRE, SINT EUSTATIUS AND SABA'
    },
    {
      code: 'BFA',
      label: 'BURKINA FASO'
    },
    {
      code: 'BGD',
      label: 'BANGLADESH'
    },
    {
      code: 'BGR',
      label: 'BULGARIA'
    },
    {
      code: 'BHR',
      label: 'BAHRAIN'
    },
    {
      code: 'BHS',
      label: 'BAHAMAS'
    },
    {
      code: 'BIH',
      label: 'BOSNIA AND HERZEGOVINA'
    },
    {
      code: 'BLM',
      label: 'SAINT BARTHELEMY'
    },
    {
      code: 'BLR',
      label: 'BELARUS'
    },
    {
      code: 'BLZ',
      label: 'BELIZE'
    },
    {
      code: 'BMU',
      label: 'BERMUDA'
    },
    {
      code: 'BOL',
      label: 'BOLIVIA'
    },
    {
      code: 'BRA',
      label: 'BRAZIL'
    },
    {
      code: 'BRB',
      label: 'BARBADOS'
    },
    {
      code: 'BRN',
      label: 'BRUNEI DARUSSALAM'
    },
    {
      code: 'BTN',
      label: 'BHUTAN'
    },
    {
      code: 'BVT',
      label: 'BOUVET ISLAND'
    },
    {
      code: 'BWA',
      label: 'BOTSWANA'
    },
    {
      code: 'CAF',
      label: 'CENTRAL AFRICAN REPUBLIC'
    },
    {
      code: 'CAN',
      label: 'CANADA'
    },
    {
      code: 'CCK',
      label: 'COCOS ISLAND'
    },
    {
      code: 'CHE',
      label: 'SWITZERLAND'
    },
    {
      code: 'CHL',
      label: 'CHILE'
    },
    {
      code: 'CHN',
      label: 'CHINA'
    },
    {
      code: 'CIV',
      label: "COTE D'IVOIRE"
    },
    {
      code: 'CMR',
      label: 'CAMEROON'
    },
    {
      code: 'COD',
      label: 'CONGO, THE DEMOCRATIC REPUBLIC'
    },
    {
      code: 'COG',
      label: 'CONGO'
    },
    {
      code: 'COK',
      label: 'COOK ISLANDS '
    },
    {
      code: 'COL',
      label: 'COLOMBIA'
    },
    {
      code: 'COM',
      label: 'COMOROS'
    },
    {
      code: 'CPV',
      label: 'CAPE VERDE'
    },
    {
      code: 'CRI',
      label: 'COSTA RICA'
    },
    {
      code: 'CUB',
      label: 'CUBA'
    },
    {
      code: 'CUW',
      label: 'CURACAO'
    },
    {
      code: 'CXR',
      label: 'CHRISTMAS ISLANDS'
    },
    {
      code: 'CYM',
      label: 'CAYMAN ISLANDS'
    },
    {
      code: 'CYP',
      label: 'CYPRUS'
    },
    {
      code: 'CZE',
      label: 'CZECH REPUBLIC'
    },
    {
      code: 'DEU',
      label: 'GERMANY'
    },
    {
      code: 'DJI',
      label: 'DJIBOUTI'
    },
    {
      code: 'DMA',
      label: 'DOMINICA'
    },
    {
      code: 'DNK',
      label: 'DENMARK'
    },
    {
      code: 'DOM',
      label: 'DOMINICAN REPUBLIC'
    },
    {
      code: 'DZA',
      label: 'ALGERIA'
    },
    {
      code: 'ECU',
      label: 'ECUADOR'
    },
    {
      code: 'EGY',
      label: 'EGYPT'
    },
    {
      code: 'ERI',
      label: 'ERITREA'
    },
    {
      code: 'ESH',
      label: 'WESTERN SAHARA'
    },
    {
      code: 'ESP',
      label: 'SPAIN'
    },
    {
      code: 'EST',
      label: 'ESTONIA'
    },
    {
      code: 'ETH',
      label: 'ETHIOPIA'
    },
    {
      code: 'FIN',
      label: 'FINLAND'
    },
    {
      code: 'FJI',
      label: 'FIJI'
    },
    {
      code: 'FLK',
      label: 'FALKLAND ISLANDS (MALVINAS)'
    },
    {
      code: 'FRA',
      label: 'FRANCE'
    },
    {
      code: 'FRO',
      label: 'FAEROE ISLANDS'
    },
    {
      code: 'FSM',
      label: 'MICRONESIA, FEDERATED STATES OF'
    },
    {
      code: 'GAB',
      label: 'GABON'
    },
    {
      code: 'GBR',
      label: 'UNITED KINGDOM'
    },
    {
      code: 'GEO',
      label: 'GEORGIA'
    },
    {
      code: 'GGY',
      label: 'GUERNSEY'
    },
    {
      code: 'GHA',
      label: 'GHANA'
    },
    {
      code: 'GIB',
      label: 'GIBRALTAR'
    },
    {
      code: 'GIN',
      label: 'GUINEA'
    },
    {
      code: 'GLP',
      label: 'GUADELOUPE'
    },
    {
      code: 'GMB',
      label: 'GAMBIA'
    },
    {
      code: 'GNB',
      label: 'GUINEA-BISSAU'
    },
    {
      code: 'GNQ',
      label: 'EQUATORIAL GUINEA'
    },
    {
      code: 'GRC',
      label: 'GREECE'
    },
    {
      code: 'GRD',
      label: 'GRENADA'
    },
    {
      code: 'GRL',
      label: 'GREENLAND'
    },
    {
      code: 'GTM',
      label: 'GUATEMALA'
    },
    {
      code: 'GUF',
      label: 'FRENCH GUIANA'
    },
    {
      code: 'GUM',
      label: 'GUAM'
    },
    {
      code: 'GUY',
      label: 'GUYANA'
    },
    {
      code: 'HKG',
      label: 'HONG KONG'
    },
    {
      code: 'HMD',
      label: 'HEARD AND MCDONALD ISLANDS'
    },
    {
      code: 'HND',
      label: 'HONDURAS'
    },
    {
      code: 'HRV',
      label: 'CROATIA'
    },
    {
      code: 'HTI',
      label: 'HAITI'
    },
    {
      code: 'HUN',
      label: 'HUNGARY'
    },
    {
      code: 'IDN',
      label: 'INDONESIA'
    },
    {
      code: 'IMN',
      label: 'ISLE OF MAN'
    },
    {
      code: 'IND',
      label: 'INDIA'
    },
    {
      code: 'IOT',
      label: 'BRITISH INDIAN OCEAN TERRITORY'
    },
    {
      code: 'IRL',
      label: 'IRELAND'
    },
    {
      code: 'IRN',
      label: 'IRAN'
    },
    {
      code: 'IRQ',
      label: 'IRAQ'
    },
    {
      code: 'ISL',
      label: 'ICELAND'
    },
    {
      code: 'ISR',
      label: 'ISRAEL'
    },
    {
      code: 'ITA',
      label: 'ITALY'
    },
    {
      code: 'JAM',
      label: 'JAMAICA'
    },
    {
      code: 'JEY',
      label: 'JERSEY (CHANNEL ISLANDS)'
    },
    {
      code: 'JOR',
      label: 'JORDAN '
    },
    {
      code: 'JPN',
      label: 'JAPAN'
    },
    {
      code: 'KAZ',
      label: 'KAZAKHSTAN'
    },
    {
      code: 'KEN',
      label: 'KENYA'
    },
    {
      code: 'KGZ',
      label: 'KYRGYZSTAN'
    },
    {
      code: 'KHM',
      label: 'CAMBODIA'
    },
    {
      code: 'KIR',
      label: 'KIRIBATI'
    },
    {
      code: 'KNA',
      label: 'ST.KITTS AND NEVIS'
    },
    {
      code: 'KOR',
      label: 'THE REPUBLIC OF KOREA'
    },
    {
      code: 'KWT',
      label: 'KUWAIT'
    },
    {
      code: 'LAO',
      label: 'LAOS'
    },
    {
      code: 'LBN',
      label: 'LEBANON'
    },
    {
      code: 'LBR',
      label: 'LIBERIA'
    },
    {
      code: 'LBY',
      label: 'LIBYAN ARAB JAMAHIRIYA'
    },
    {
      code: 'LCA',
      label: 'SAINT LUCIA '
    },
    {
      code: 'LIE',
      label: 'LIECHTENSTEIN '
    },
    {
      code: 'LKA',
      label: 'SRI LANKA  '
    },
    {
      code: 'LSO',
      label: 'LESOTHO'
    },
    {
      code: 'LTU',
      label: 'LITHUANIA'
    },
    {
      code: 'LUX',
      label: 'LUXEMBOURG'
    },
    {
      code: 'LVA',
      label: 'LATVIA '
    },
    {
      code: 'MAC',
      label: 'MACAO'
    },
    {
      code: 'MAF',
      label: 'SAINT MARTIN (FRENCH PART)'
    },
    {
      code: 'MAR',
      label: 'MOROCCO'
    },
    {
      code: 'MCO',
      label: 'MONACO'
    },
    {
      code: 'MDA',
      label: 'MOLDOVA, REPUBLIC OF'
    },
    {
      code: 'MDG',
      label: 'MADAGASCAR'
    },
    {
      code: 'MDV',
      label: 'MALDIVES'
    },
    {
      code: 'MEX',
      label: 'MEXICO'
    },
    {
      code: 'MHL',
      label: 'MARSHALL ISLANDS '
    },
    {
      code: 'MKD',
      label: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF'
    },
    {
      code: 'MLI',
      label: 'MALI'
    },
    {
      code: 'MLT',
      label: 'MALTA'
    },
    {
      code: 'MMR',
      label: 'MYANMAR'
    },
    {
      code: 'MNE',
      label: 'MONTENEGRO'
    },
    {
      code: 'MNG',
      label: 'MONGOLIA '
    },
    {
      code: 'MNP',
      label: 'NORTHERN MARIANA ISLANDS'
    },
    {
      code: 'MOZ',
      label: 'MOZAMBIQUE'
    },
    {
      code: 'MRT',
      label: 'MAURITANIA'
    },
    {
      code: 'MSR',
      label: 'MONTSERRAT'
    },
    {
      code: 'MTQ',
      label: 'MARTINIQUE'
    },
    {
      code: 'MUS',
      label: 'MAURITIUS'
    },
    {
      code: 'MWI',
      label: 'MALAWI'
    },
    {
      code: 'MYS',
      label: 'MALAYSIA'
    },
    {
      code: 'MYT',
      label: 'MAYOTTE'
    },
    {
      code: 'NAM',
      label: 'NAMIBIA'
    },
    {
      code: 'NCL',
      label: 'NEW CALEDONIA '
    },
    {
      code: 'NER',
      label: 'NIGER'
    },
    {
      code: 'NFK',
      label: 'NORFOLK ISLAND'
    },
    {
      code: 'NGA',
      label: 'NIGERIA'
    },
    {
      code: 'NIC',
      label: 'NICARAGUA'
    },
    {
      code: 'NIU',
      label: 'NIUE'
    },
    {
      code: 'NLD',
      label: 'NETHERLANDS'
    },
    {
      code: 'NOR',
      label: 'NORWAY'
    },
    {
      code: 'NPL',
      label: 'NEPAL'
    },
    {
      code: 'NRU',
      label: 'NAURU'
    },
    {
      code: 'NZL',
      label: 'NEW ZEALAND '
    },
    {
      code: 'OMN',
      label: 'OMAN'
    },
    {
      code: 'PAK',
      label: 'PAKISTAN'
    },
    {
      code: 'PAN',
      label: 'PANAMA'
    },
    {
      code: 'PCN',
      label: 'PITCAIRN'
    },
    {
      code: 'PER',
      label: 'PERU'
    },
    {
      code: 'PHL',
      label: 'PHILIPPINES'
    },
    {
      code: 'PLW',
      label: 'PALAU'
    },
    {
      code: 'PNG',
      label: 'PAPUA NEW GUINEA'
    },
    {
      code: 'POL',
      label: 'POLAND'
    },
    {
      code: 'PRI',
      label: 'PUERTO RICO'
    },
    {
      code: 'PRK',
      label: 'DEMOC.PEOPLES REP.OF KOREA'
    },
    {
      code: 'PRT',
      label: 'PORTUGAL'
    },
    {
      code: 'PRY',
      label: 'PARAGUAY'
    },
    {
      code: 'PSE',
      label: 'PALESTINIAN TERRITORY, OCCUPIED'
    },
    {
      code: 'PYF',
      label: 'FRENCH POLYNESIA'
    },
    {
      code: 'QAT',
      label: 'QATAR'
    },
    {
      code: 'REU',
      label: 'REUNION'
    },
    {
      code: 'ROU',
      label: 'ROMANIA'
    },
    {
      code: 'RUS',
      label: 'RUSSIAN FEDERATION (USSR)'
    },
    {
      code: 'RWA',
      label: 'RWANDA'
    },
    {
      code: 'SAU',
      label: 'SAUDI ARABIA'
    },
    {
      code: 'SDN',
      label: 'SUDAN'
    },
    {
      code: 'SEN',
      label: 'SENEGAL'
    },
    {
      code: 'SGP',
      label: 'SINGAPORE'
    },
    {
      code: 'SGS',
      label: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLAND'
    },
    {
      code: 'SHN',
      label: 'ST. HELENA '
    },
    {
      code: 'SJM',
      label: 'SVALBARD AND JAN MAYEN ISLANDS'
    },
    {
      code: 'SLB',
      label: 'SOLOMON ISLANDS'
    },
    {
      code: 'SLE',
      label: 'SIERRA LEONE'
    },
    {
      code: 'SLV',
      label: 'EL SALVADOR'
    },
    {
      code: 'SMR',
      label: 'SAN MARINO'
    },
    {
      code: 'SOM',
      label: 'SOMALIA'
    },
    {
      code: 'SPM',
      label: 'ST. PIERRE AND MIQUELON'
    },
    {
      code: 'SRB',
      label: 'SERBIA & MONTENEGRO '
    },
    {
      code: 'SSD',
      label: 'SOUTH SUDAN'
    },
    {
      code: 'STP',
      label: 'SAO TOME AND PRINCIPE'
    },
    {
      code: 'SUR',
      label: 'SURINAME'
    },
    {
      code: 'SVK',
      label: 'SLOVAK REPUBLIC'
    },
    {
      code: 'SVN',
      label: 'SLOVENIA'
    },
    {
      code: 'SWE',
      label: 'SWEDEN'
    },
    {
      code: 'SWZ',
      label: 'ESWATINI, KINGDOM OF (SWAZILAND)'
    },
    {
      code: 'SXM',
      label: 'SINT MAARTEN (DUTCH PART)'
    },
    {
      code: 'SYC',
      label: 'SEYCHELLES'
    },
    {
      code: 'SYR',
      label: 'SYRIAN ARAB REPUBLIC'
    },
    {
      code: 'TCA',
      label: 'TURKS AND CAICOS ISLANDS'
    },
    {
      code: 'TCD',
      label: 'CHAD'
    },
    {
      code: 'TGO',
      label: 'TOGO'
    },
    {
      code: 'THA',
      label: 'THAILAND'
    },
    {
      code: 'TJK',
      label: 'TAJIKISTAN'
    },
    {
      code: 'TKL',
      label: 'TOKELAU'
    },
    {
      code: 'TKM',
      label: 'TURKMENISTAN'
    },
    {
      code: 'TLS',
      label: 'TIMOR-LESTE '
    },
    {
      code: 'TON',
      label: 'TONGA'
    },
    {
      code: 'TTO',
      label: 'TRINIDAD AND TOBAGO'
    },
    {
      code: 'TUN',
      label: 'TUNISIA'
    },
    {
      code: 'TUR',
      label: 'TURKIYE '
    },
    {
      code: 'TUV',
      label: 'TUVALU'
    },
    {
      code: 'TWN',
      label: 'TAIWAN'
    },
    {
      code: 'TZA',
      label: 'TANZANIA UNITED REPUBLIC'
    },
    {
      code: 'UGA',
      label: 'UGANDA'
    },
    {
      code: 'UKR',
      label: 'UKRAINE'
    },
    {
      code: 'UMI',
      label: 'UNITED STATES MINOR OUTLYING ISLANDS'
    },
    {
      code: 'URY',
      label: 'URUGUAY'
    },
    {
      code: 'USA',
      label: 'UNITED STATES OF AMERICA'
    },
    {
      code: 'UZB',
      label: 'UZBEKISTAN'
    },
    {
      code: 'VAT',
      label: 'VATICAN CITY STATE (HOLY SEE)'
    },
    {
      code: 'VCT',
      label: 'SAINT VINCENT AND GRENADINES'
    },
    {
      code: 'VEN',
      label: 'VENEZUELA'
    },
    {
      code: 'VGB',
      label: 'VIRGIN ISLANDS(BRITISH)'
    },
    {
      code: 'VIR',
      label: 'VIRGIN ISLANDS(US)'
    },
    {
      code: 'VNM',
      label: 'VIETNAM'
    },
    {
      code: 'VUT',
      label: 'VANUATU'
    },
    {
      code: 'WLF',
      label: 'WALLIS AND FUTUNA ISLANDS'
    },
    {
      code: 'WSM',
      label: 'SAMOA'
    },
    {
      code: 'YEM',
      label: 'YEMEN'
    },
    {
      code: 'ZAF',
      label: 'SOUTH AFRICA'
    },
    {
      code: 'ZMB',
      label: 'ZAMBIA'
    },
    {
      code: 'ZWE',
      label: 'ZIMBABWE'
    }
  ]);
  const [stateList, setStateList] = useState([
    {
      code: '00',
      label: 'All States'
    },
    {
      code: '01',
      label: 'Johor'
    },
    {
      code: '02',
      label: 'Kedah'
    },
    {
      code: '03',
      label: 'Kelantan'
    },
    {
      code: '04',
      label: 'Melaka'
    },
    {
      code: '05',
      label: 'Negeri Sembilan'
    },
    {
      code: '06',
      label: 'Pahang'
    },
    {
      code: '07',
      label: 'Pulau Pinang'
    },
    {
      code: '08',
      label: 'Perak'
    },
    {
      code: '09',
      label: 'Perlis'
    },
    {
      code: '10',
      label: 'Selangor'
    },
    {
      code: '11',
      label: 'Terengganu'
    },
    {
      code: '12',
      label: 'Sabah'
    },
    {
      code: '13',
      label: 'Sarawak'
    },
    {
      code: '14',
      label: 'Wilayah Persekutuan Kuala Lumpur'
    },
    {
      code: '15',
      label: 'Wilayah Persekutuan Labuan'
    },
    {
      code: '16',
      label: 'Wilayah Persekutuan Putrajaya'
    },
    {
      code: '17',
      label: 'Not Applicable'
    }
  ]);
  const [linkProfileList, setLinkProfileList] = useState([]);

  useEffect(() => {
    console.log('CreateEinvoiceModal props', props);

    if (props.visible) {
      GetLinkProfileList();
      setIsGuestSelfServiceEnabled(false); // Reset state when modal opens

      const internalInvoiceNo =
        props.reservationInvoiceNumber != null && String(props.reservationInvoiceNumber).trim()
          ? String(props.reservationInvoiceNumber).trim()
          : null;
      const documentNoForEinvoice = internalInvoiceNo || 'AUTO';

      props.form.setFieldsValue({
        invoiceAmountType: 'grossPrice',
        documentNo: documentNoForEinvoice,
        totalSalesTax: guard(() => transactions.find(transaction => transaction.subType === 'sst').amount, 0) || 0,
        billReferenceNumber: props.confirmationCode,
        // checkInDate: props.checkInDate,
        // checkOutDate: props.checkOutDate,
        // bookingSource: props.bookingSource,
        // amount: props.amount,
        amount: props.grossPrice,
        totalTourismTax: props.tourismTax,
        totalHeritageTax: props.heritageTax,
        invoiceDescription:
          'Check-in: ' +
          props.checkInDate +
          ', Check-out: ' +
          props.checkOutDate +
          ', Source: ' +
          props.bookingSource +
          ', ' +
          props.invoiceDescription.propertyOptions.find(property => property.value === props.invoiceDescription.defaultProperty).label +
          ', ' +
          props.invoiceDescription.roomTypeOptions.find(roomType => roomType.value === props.invoiceDescription.defaultRoomType).label +
          ', ' +
          props.invoiceDescription.unitOptions.find(unit => unit.value === props.invoiceDescription.defaultUnit).label +
          ', ' +
          props.invoiceDescription.defaultNoPax +
          'pax'
      });
    }

    return () => {};
  }, [props.visible, props.reservationInvoiceNumber]);

  const GetLinkProfileList = async () => {
    setLoading(true);
    const res = await getLinkProfileList();
    console.log('getLinkProfileList', res);
    setLoading(false);
    if (res.status >= 200 && res.status < 300) {
      setLinkProfileList(
        res.data.map(item => ({
          ...item,
          value: item._id,
          label: item.name
        }))
      );
      // Update guest self service enabled state if projectId is already selected
      const selectedProjectId = getFieldValue('projectId');
      if (selectedProjectId) {
        const selectedProfile = res.data.find(item => item._id === selectedProjectId);
        if (selectedProfile && selectedProfile.plan) {
          const isProPlan = selectedProfile.plan === 'Pro' || selectedProfile.plan === 'Pro (Promo)';
          setIsGuestSelfServiceEnabled(isProPlan);
        } else {
          setIsGuestSelfServiceEnabled(false);
        }
      }
    }
  };

  const handleFormModeChange = e => {
    const newMode = e.target.value;
    setFormMode(newMode);
    props.form.setFieldsValue({
      formMode: newMode
    });
  };

  const handleOnFormSubmit = e => {
    e.preventDefault();

    props.form.validateFields((err, values) => {
      console.log('err', err);
      console.log('values', values);

      if (!err) {
        let totalTaxAmount = (values.totalSalesTax || 0) + (values.totalTourismTax || 0) + (values.totalHeritageTax || 0);
        let filteredValues = {
          projectId: values.projectId,
          documentType: '01',
          documentNo: values.documentNo,
          billReferenceNumber: values.billReferenceNumber,
          documentDate: moment(),
          documentTime: moment(),
          confirmationCode: props.confirmationCode,
          sourceId: props.sourceId,
          checkInDate: props.checkInDate,
          checkOutDate: props.checkOutDate,
          ota: props.bookingSource,
          totalPayableAmount: values.amount.toFixed(2),
          totalTaxAmount: totalTaxAmount.toFixed(2),
          totalSalesTax: values.totalSalesTax ? values.totalSalesTax.toFixed(2) : 0,
          totalTourismTax: values.totalTourismTax ? values.totalTourismTax.toFixed(2) : 0,
          totalHeritageTax: values.totalHeritageTax ? values.totalHeritageTax.toFixed(2) : 0,
          currency: 'MYR',
          currencyExRate: 1,
          totalExcludingTax: 0,
          taxType: '06',
          invoiceDescription: values.invoiceDescription,
          userDetails: {
            name: values.name,
            claimAs: values.claimAs,
            individualId: values.individualId || undefined,
            idNumber: values.idNumber || undefined,
            brn: values.brn || undefined,
            tinNumber:
              values.individualId === 'NRIC' || values.individualId === 'Army'
                ? 'EI00000000010'
                : values.individualId === 'Passport'
                ? 'EI00000000020'
                : values.tinNumber,
            tourismTaxNumber: values.tourismTaxNumber || undefined,
            sstRegistrationNumber: values.sstRegistrationNumber || undefined,
            country: values.country,
            state: values.state,
            addressLine0: values.addressLine0,
            addressLine1: values.addressLine1,
            addressLine2: values.addressLine2,
            postalCode: values.postalCode,
            city: values.city,
            contact: values.contact,
            email: values.email
          }
        };

        // Calculate totalSalesTax value
        const totalSalesTax = values.totalSalesTax;
        console.log(totalSalesTax, 1213);
        if (totalSalesTax !== 0 && values.amount > 0) {
          filteredValues.totalSalesTax = totalSalesTax;
          filteredValues.totalExcludingTax = (values.amount - totalSalesTax).toFixed(2);
          filteredValues.taxType = '02';
          filteredValues.totalTaxAmount = totalSalesTax;
        }

        if (formMode === 'guestSelfService') {
          // Handle guest self-service mode
          Modal.confirm({
            title: 'Generate Guest Self-Service Link?',
            content: 'This will create a link for the customer to fill up the form themselves.',
            onOk() {
              setLoading(true);
              // Add isCustomerSelfService flag to the request
              console.log(filteredValues, 1215);

              let selfServiceData = {
                ...filteredValues,
                isCustomerSelfServiceForm: true
              };
              delete selfServiceData.userDetails;
              createCustomerSelfServiceForm(selfServiceData).then(response => {
                setLoading(false);

                if (response.status >= 200 && response.status < 300) {
                  props.onCancel();

                  const linkData = response.data;
                  console.log(response, 1230);
                  const formLink = `${REACT_APP_E_INVOICE_URL}/customer-self-service-form?invoiceId=${linkData._id}&projectId=${linkData.projectId}`;

                  Modal.success({
                    title: 'Guest Self-Service Link Generated!',
                    content: (
                      <div>
                        <p>The link has been generated successfully.</p>
                        <div
                          style={{
                            background: '#f5f5f5',
                            padding: '12px',
                            borderRadius: '6px',
                            margin: '12px 0',
                            wordBreak: 'break-all'
                          }}
                        >
                          <strong>Link:</strong>
                          <br />
                          <a href={formLink} target="_blank" rel="noopener noreferrer">
                            {formLink}
                          </a>
                        </div>
                        <p>
                          <strong>Expires:</strong>{' '}
                          {linkData.expiresAt ? moment(linkData.expiresAt).format('YYYY-MM-DD HH:mm:ss') : '72 hours from now'}
                        </p>
                        <p>You can share this link with the customer.</p>
                        <Alert
                          message="Link Information"
                          description={`Invoice ID: ${linkData._id || 'N/A'}, Project ID: ${linkData.projectId || 'N/A'}`}
                          type="info"
                          showIcon
                          style={{ marginTop: '12px' }}
                        />
                      </div>
                    ),
                    onOk() {
                      // Copy link to clipboard
                      if (formLink) {
                        navigator.clipboard.writeText(formLink);
                        message.success('Link copied to clipboard!');
                      }
                    }
                  });
                } else {
                  message.error(response.data.message || 'Failed to generate guest self-service link');
                }
              });
            }
          });
        } else {
          // Handle customer service mode (original logic)
          Modal.confirm({
            title: 'Confirm Create e-Invoice?',
            onOk() {
              setLoading(true);
              reservationCreateEinvoice(filteredValues).then(response => {
                console.log('response', response);

                if (response.status >= 200 && response.status < 300) {
                  props.onCancel();

                  setLoading(false);

                  Modal.success({
                    title: 'e-Invoice successfully created!',
                    onOk() {
                      if (window.location.search.includes('_id')) {
                        const url = new URL(window.location.href);
                        const id = url.searchParams.get('_id');
                        window.location.assign(`/e-invoice?_id=${id}`);
                      } else {
                        window.location.assign('/e-invoice');
                      }
                    }
                  });
                } else {
                  message.error(response.data.message || 'Failed to create e-Invoice');
                  setLoading(false);
                }
              });
            }
          });
        }
      }
    });
  };

  return (
    <Modal
      title={`Create e-Invoice`}
      style={{ minHeight: '80vh', minWidth: '200px', overflow: 'hidden' }}
      visible={props.visible}
      maskClosable={false}
      afterClose={() => {
        props.form.resetFields();
      }}
      onCancel={() => {
        props.onCancel();
      }}
      footer={
        <div>
          <Row type="flex" justify="end">
            <Col>
              <Button
                key="back"
                onClick={() => {
                  props.onCancel();
                }}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button key="submit" onClick={handleOnFormSubmit} type="primary" loading={loading}>
                {formMode === 'guestSelfService' ? 'Generate Link' : 'Submit'}
              </Button>
            </Col>
          </Row>
        </div>
      }
    >
      <Form layout="horizontal" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
        <Alert
          message={
            props.reservationInvoiceNumber != null && String(props.reservationInvoiceNumber).trim()
              ? `This reservation has an internal invoice number ${props.reservationInvoiceNumber}; it will be used as the e-Invoice document number.`
              : 'No internal invoice number on this reservation; e-Invoice will use AUTO (generated by the e-Invoice service).'
          }
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
        />

        <Form.Item label="Company Profile">
          {getFieldDecorator('projectId', {
            rules: [{ required: true, message: 'Company Profile is required' }]
          })(
            <Select
              placeholder="Company Profile"
              showSearch
              filterOption={(input, option) => {
                if (!input) return true;
                const regex = new RegExp(input, 'i');
                return regex.test(option.props.children);
              }}
              disabled={loading}
              onChange={value => {
                // Update guest self service enabled state based on selected profile
                const selectedProfile = linkProfileList.find(item => item._id === value);
                if (selectedProfile && selectedProfile.plan) {
                  const isProPlan = planToEnableGuestSelfService.includes(selectedProfile.plan);
                  setIsGuestSelfServiceEnabled(isProPlan);
                  // Reset form mode to customerService if the selected profile doesn't support guestSelfService
                  if (!isProPlan && getFieldValue('formMode') === 'guestSelfService') {
                    setFormMode('customerService');
                    props.form.setFieldsValue({
                      formMode: 'customerService'
                    });
                  }
                } else {
                  setIsGuestSelfServiceEnabled(false);
                }
              }}
            >
              {linkProfileList.map(item => {
                const subscriptionStatus = guard(() => item.order.subscriptionStatus, 'canceled');
                return (
                  <Select.Option
                    key={item.value}
                    value={item.value}
                    disabled={subscriptionStatus === 'past_due' || subscriptionStatus === 'canceled'}
                  >
                    {item.label}
                  </Select.Option>
                );
              })}
            </Select>
          )}
        </Form.Item>
        <Form.Item label="Form Mode" help={isGuestSelfServiceEnabled ? '' : 'Guest Self Service Form require Pro plan.'}>
          {getFieldDecorator('formMode', {
            rules: [
              {
                required: true,
                message: 'Please select a form mode'
              }
            ],
            initialValue: 'customerService'
          })(
            <Radio.Group optionType="button" buttonStyle="solid" onChange={handleFormModeChange}>
              <Radio.Button value="customerService">Form</Radio.Button>
              <Radio.Button value="guestSelfService" disabled={!isGuestSelfServiceEnabled}>
                Guest Self Service Form
              </Radio.Button>
            </Radio.Group>
          )}
        </Form.Item>
        {getFieldValue('formMode') === 'guestSelfService' && (
          <Alert
            message="Guest Self Service Mode"
            description="A link will be generated for the customer to fill up the form themselves. This saves time for customer service."
            type="success"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        <Form.Item
          style={{
            display: 'none'
          }}
          label="Invoice Number"
        >
          {getFieldDecorator('documentNo')(<Input loading={loading} />)}
        </Form.Item>
        <Form.Item label="Reference Number">{getFieldDecorator('billReferenceNumber')(<Input loading={loading} />)}</Form.Item>
        {/* <Form.Item label="Check In Date">{getFieldDecorator('checkInDate')(<Input disabled={true} />)}</Form.Item>
        <Form.Item label="Check Out Date">{getFieldDecorator('checkOutDate')(<Input disabled={true} />)}</Form.Item>
        <Form.Item label="OTA">{getFieldDecorator('bookingSource')(<Input disabled={true} />)}</Form.Item> */}
        <Form.Item label="Invoice Amount Type">
          {getFieldDecorator('invoiceAmountType', {
            rules: [{ required: true, message: 'Invoice Amount Type is required' }]
          })(
            <Radio.Group
              buttonStyle="solid"
              onChange={e => {
                // console.log(e.target.value, 1415);
                // console.log(props.grossPrice, 1416);
                // console.log(props.amount, 1417);
                switch (e.target.value) {
                  case 'grossPrice':
                    props.form.setFieldsValue({
                      amount: props.grossPrice
                    });
                    break;
                  case 'netPrice':
                    props.form.setFieldsValue({
                      amount: props.amount
                    });
                    break;
                }
              }}
            >
              <Radio.Button value="grossPrice">Gross Price</Radio.Button>
              <Radio.Button value="netPrice">Net Price</Radio.Button>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item label="Invoice Amount (RM)">
          {getFieldDecorator('amount', {})(<InputNumber min={0} precision={2} loading={loading} style={{ width: '100%' }} />)}
        </Form.Item>
        <Form.Item label="Service Tax Amount(RM)" help="8% SST Service Tax. Set 0 if not applicable.">
          {getFieldDecorator('totalSalesTax', {
            initialValue: 0
          })(<InputNumber min={0} precision={2} loading={loading} placeholder="0.00" style={{ width: '100%' }} />)}
        </Form.Item>
        <Form.Item label="Total Tourism Tax (RM)">
          {getFieldDecorator('totalTourismTax', {
            initialValue: 0
          })(<InputNumber min={0} precision={2} loading={loading} placeholder="0.00" style={{ width: '100%' }} />)}
        </Form.Item>
        <Form.Item label="Total Heritage Tax (RM)">
          {getFieldDecorator('totalHeritageTax', {
            initialValue: 0
          })(<InputNumber min={0} precision={2} loading={loading} placeholder="0.00" style={{ width: '100%' }} />)}
        </Form.Item>
        <Form.Item label="Invoice Description">
          {getFieldDecorator('invoiceDescription', {
            rules: [{ required: true, message: 'Invoice Description is required' }]
          })(<Input.TextArea disabled={loading} autoSize={{ minRows: 3, maxRows: 3 }} />)}
        </Form.Item>

        {getFieldValue('formMode') !== 'guestSelfService' && (
          <>
            <Divider>Guest Details</Divider>

            <Form.Item label="Name">
              {getFieldDecorator('name', {
                rules: [
                  {
                    required: true,
                    message: 'Name is required'
                  }
                ]
              })(<Input placeholder="Name" />)}
            </Form.Item>

            <Form.Item label="Claim As">
              {getFieldDecorator('claimAs', {
                rules: [
                  {
                    required: true,
                    message: 'Please select claim as'
                  }
                ],
                initialValue: 'Individual'
              })(
                <Radio.Group optionType="button" buttonStyle="solid">
                  <Radio.Button value="Individual">Individual</Radio.Button>
                  <Radio.Button value="Company">Company</Radio.Button>
                </Radio.Group>
              )}
            </Form.Item>

            {(() => {
              const claimAs = getFieldValue('claimAs');
              const individualId = getFieldValue('individualId');
              return (
                <>
                  {claimAs === 'Individual' ? (
                    <>
                      <Form.Item label="Individual ID">
                        {getFieldDecorator('individualId', {
                          rules: [
                            {
                              required: true,
                              message: 'Please select Individual ID'
                            }
                          ],
                          initialValue: 'NRIC'
                        })(
                          <Radio.Group optionType="button" buttonStyle="solid">
                            <Radio.Button value="NRIC">NRIC</Radio.Button>
                            <Radio.Button value="Passport">Passport</Radio.Button>
                            <Radio.Button value="Army">Army</Radio.Button>
                          </Radio.Group>
                        )}
                      </Form.Item>

                      <Form.Item
                        label={
                          individualId === 'NRIC'
                            ? 'NRIC Number'
                            : individualId === 'Passport'
                            ? 'Passport Number'
                            : individualId === 'Army'
                            ? 'Army Number'
                            : 'NRIC Number'
                        }
                      >
                        {getFieldDecorator('idNumber', {
                          rules: [
                            {
                              required: individualId === 'NRIC' && getFieldValue('brn') ? false : true,
                              message:
                                individualId === 'NRIC'
                                  ? 'NRIC Number is required'
                                  : individualId === 'Passport'
                                  ? 'Passport Number is required'
                                  : individualId === 'Army'
                                  ? 'Army Number is required'
                                  : ''
                            },
                            ...(individualId === 'NRIC'
                              ? [
                                  {
                                    pattern: /^[0-9]{12}$/,
                                    message: 'Please enter a valid NRIC Number'
                                  }
                                ]
                              : [])
                          ]
                        })(
                          <Input
                            placeholder={
                              individualId === 'NRIC'
                                ? 'NRIC Number'
                                : individualId === 'Passport'
                                ? 'Passport Number'
                                : individualId === 'Army'
                                ? 'Army Number'
                                : ''
                            }
                          />
                        )}
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Form.Item label="BRN" tooltip="New Business Registration Number">
                        {getFieldDecorator('brn', {
                          rules: [
                            {
                              required: getFieldValue('nricNumber') && String(getFieldValue('nricNumber')).length === 12 ? false : true,
                              message: 'BRN is required'
                            }
                          ]
                        })(<Input placeholder="BRN" />)}
                      </Form.Item>

                      <Form.Item label="Tin Number" tooltip="Tax Identification Number">
                        {getFieldDecorator('tinNumber', {
                          rules: [
                            {
                              required: true,
                              message: 'Tin Number is required'
                            }
                          ]
                        })(<Input placeholder="Tin Number" />)}
                      </Form.Item>

                      <Form.Item label="Tourism Tax Number" tooltip="Tourism Tax Number">
                        {getFieldDecorator('tourismTaxRegistrationNumber', {
                          // rules: [
                          //   {
                          //     required: true,
                          //     message: 'Tourism Tax Number is required'
                          //   }
                          // ]
                        })(<Input placeholder="Tourism Tax Number" />)}
                      </Form.Item>

                      <Form.Item label="SST" tooltip="SST Registration Number">
                        {getFieldDecorator('sstRegistrationNumber')(
                          <Input placeholder="SST Registration Number" disabled={loading} maxLength={15} />
                        )}
                      </Form.Item>
                    </>
                  )}

                  <Divider>Address</Divider>

                  <Form.Item label="Country">
                    {getFieldDecorator('country', {
                      rules: [
                        {
                          required: true,
                          message: 'Country is required'
                        }
                      ]
                    })(
                      <Select
                        showSearch
                        filterOption={(input, option) => {
                          if (!input) return true;
                          const regex = new RegExp(input, 'i');
                          return regex.test(option.props.children);
                        }}
                        onChange={() => {
                          props.form.setFieldsValue({
                            state: undefined
                          });
                        }}
                        disabled={loading}
                        placeholder="Country"
                      >
                        {countryList.map(item => (
                          <Select.Option key={item.code} value={item.code}>
                            {item.code} - {item.label}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>

                  {getFieldValue('country') && getFieldValue('country') !== 'MYS' ? (
                    <Form.Item label="State">
                      {getFieldDecorator('state', {
                        rules: [
                          {
                            required: true,
                            message: 'State is required'
                          }
                        ]
                      })(<Input placeholder="Enter State" />)}
                    </Form.Item>
                  ) : (
                    <Form.Item label="State">
                      {getFieldDecorator('state', {
                        rules: [
                          {
                            required: true,
                            message: 'State is required'
                          }
                        ]
                      })(
                        <Select
                          placeholder="State"
                          showSearch
                          filterOption={(input, option) => {
                            if (!input) return true;
                            const regex = new RegExp(input, 'i');
                            return regex.test(option.props.children);
                          }}
                          disabled={loading}
                        >
                          {stateList.map(item => (
                            <Select.Option key={item.code} value={item.code}>
                              {item.code} - {item.label}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  )}

                  <Form.Item label="Address 1">
                    {getFieldDecorator('addressLine0', {
                      rules: [
                        {
                          required: true,
                          message: 'Address 1 required'
                        }
                      ]
                    })(<Input placeholder="Address 1" />)}
                  </Form.Item>

                  <Form.Item label="Address 2">{getFieldDecorator('addressLine1')(<Input placeholder="Address 2" />)}</Form.Item>

                  <Form.Item label="Address 3">{getFieldDecorator('addressLine2')(<Input placeholder="Address 3" />)}</Form.Item>

                  <Form.Item label="Postal Code">
                    {getFieldDecorator('postalCode', {
                      rules: [
                        {
                          required: true,
                          message: 'Postal Code is required'
                        },
                        {
                          pattern: /^[0-9]*$/,
                          message: 'Please enter a valid postal code'
                        }
                      ]
                    })(<Input placeholder="Postal Code" disabled={loading} />)}
                  </Form.Item>

                  <Form.Item label="City">
                    {getFieldDecorator('city', {
                      rules: [
                        {
                          required: true,
                          message: 'City is required'
                        }
                      ]
                    })(<Input placeholder="City" disabled={loading} />)}
                  </Form.Item>

                  <Form.Item label="Contact Number">
                    {getFieldDecorator('contact', {
                      rules: [
                        {
                          required: true,
                          message: 'Contact is required'
                        },
                        {
                          max: 12,
                          message: 'Contact No. must not more than 12 digit'
                        },
                        {
                          pattern: /^[0-9]+$/,
                          message: 'Contact No. must be number only'
                        }
                      ]
                    })(<Input placeholder="60123456789" />)}
                  </Form.Item>

                  <Form.Item label="Email">
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          type: 'email',
                          message: 'Please insert valid email'
                        },
                        {
                          required: true,
                          message: 'Please insert your email'
                        }
                      ]
                    })(<Input placeholder="Email" />)}
                  </Form.Item>
                </>
              );
            })()}
          </>
        )}
      </Form>
    </Modal>
  );
};

export default withAppContext(Form.create()(CreateEinvoiceModal));
